import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import cs from "classnames";

import { createObject, updateObject } from "../../../../../redux/dataSlice";
import { filterProperties } from "pages/Root/helpers";
import useNotifications from "hooks/useNotifications";

PlaceForm.propTypes = {
	initialValues: PropTypes.object,
	id: PropTypes.string,
};

export default function PlaceForm({ initialValues, id = undefined }) {
	const defaultValues = {
		name: "",
		description: "",
	};
	const mergedDefaults = { ...defaultValues, ...initialValues };

	const dispatch = useDispatch();

	const validationSchema = Yup.object().shape({
		name: Yup.string().min(2, "Příliš krátký název").required("Povinné pole"),
		description: Yup.string().nullable(),
	});

	// Retrieve notifications for specific category of entity using the useNotifications hook
	const notifications = useNotifications("places");

	// Define state for managing form key to trigger re-render
	const [formKey, setFormKey] = useState(0);

	// Update form key whenever initialValues change
	useEffect(() => setFormKey(prevState => prevState + 1), [initialValues]);

	return (
		<section>
			<h3>
				{id ? "Upravit" : "Vytvořit nové"} místo {mergedDefaults.name}
			</h3>
			{/* Render notifications reflecting updates made by this form, if available */}
			{notifications.length ? (
				<span className={cs("notification_span", notifications[0]?.type)}>
					{notifications[0]?.message}
				</span>
			) : null}
			<Formik
				key={formKey}
				initialValues={filterProperties(mergedDefaults, Object.keys(defaultValues))}
				validationSchema={validationSchema}
				onSubmit={values => {
					dispatch(
						id
							? updateObject({ entity: "places", id, values })
							: createObject({ entity: "places", values })
					);
					// Increment form key to trigger re-render
					setFormKey(prevState => prevState + 1);
				}}>
				{({ isSubmitting, handleReset }) => (
					<Form className="form">
						<label>
							Název
							<Field type="text" name="name" style={{ width: "16rem" }} />
							<ErrorMessage name="name" component="span" className="error-message" />
						</label>
						<label>
							Popis
							<Field type="text" name="description" style={{ width: "20rem" }} />
							<ErrorMessage name="description" component="span" className="error-message" />
						</label>
						<div></div>
						<button
							type="button"
							className="action_button reset red"
							onClick={handleReset}
							tabIndex="-1">
							Zrušit změny
						</button>
						<div></div>
						<button type="submit" className="action_button" disabled={isSubmitting}>
							{id ? "Upravit" : "Vytvořit"}
						</button>
					</Form>
				)}
			</Formik>
		</section>
	);
}
